module.exports = __webpack_public_path__ + "img/img_1.b8d48576.png";